import React, { Component } from 'react';
import Popup from 'reactjs-popup';
import { isFunction } from 'lodash';
import { Container, Row, Col } from 'react-bootstrap';

import SpinningWheel from '../../Parts/SpinningWheel';
import Button from '../../Parts/Button';
import { toast } from 'react-toastify';

class QuotePricingLockedNew extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
		};

		this.unlockQuote = this.unlockQuote.bind(this);
	}

	unlockQuote(close) {
		this.setState({
			loading: true,
		});
		this.props.unlockQuote(() => {
			toast('Quote unlocked successfully', {
				type: 'success',
			});
			close();
			this.props.setEditable(true);
		});
	}

	render() {
		const self = this;

		const closeModal = (e) => {
			self.props.setShowEditQuoteDisclaimer(false);
		};

		const { showEditQuoteDisclaimer } = self.props;

		const open =
			showEditQuoteDisclaimer === true ||
			showEditQuoteDisclaimer > 0 ||
			typeof showEditQuoteDisclaimer.extraMessage === 'string' ||
			isFunction(showEditQuoteDisclaimer.action);

		const shadesThatNeedRepricing = this.props.newQuote.Data.shadeAssemblies.Items.filter((s) =>
			this.props.newQuote.Data.shadeSubstitute(s.sequence_id).needsRepricing()
		);
		const quoteAccessoriesNeedingUnlocked =
			this.props.newQuote.QuoteSubstitution.accessories.filter((a) =>
				this.props.newQuote.Data.isAccessoryOld2(a.line_number)
			);

		const repriceCount =
			shadesThatNeedRepricing.length + quoteAccessoriesNeedingUnlocked.length;

		const extraMessage = showEditQuoteDisclaimer.extraMessage
			? self.props.showEditQuoteDisclaimer.extraMessage
			: null;

		const quoteType = self.props.newQuote.QuoteType.toLowerCase();

		return (
			<>
				<Button
					onClick={() => this.props.setShowEditQuoteDisclaimer(true)}
					fluid
					fullWidth
					color={quoteType ?? 'green'}
				>
					Edit Quote
				</Button>
				<Popup
					open={open}
					className="edit mobile-modal"
					modal
					closeOnDocumentClick={false}
					onClose={closeModal}
				>
					{(close) => (
						<Container className="local-bootstrap">
							{repriceCount > 0 ? (
								<>
									<Row>
										<Col>
											<h4 className={`text-${quoteType}`}>Edit Quote</h4>
										</Col>
									</Row>
									<Row>
										<Col>
											<Row>
												<Col>
													All prices are valid for 90 days without risk of
													price changes.
												</Col>
											</Row>
											<Row>
												<Col>
													{`${
														repriceCount == 1
															? 'There is currently 1 shade/accessory '
															: `There are currently ${repriceCount} shades/accessories `
													}that need${
														repriceCount == 0 ? 's' : ''
													} repricing because they are older than 90 days.`}
												</Col>
											</Row>
											<Row>
												<Col>
													Would you like to unlock this quote and reprice
													these shades?
												</Col>
											</Row>
										</Col>
									</Row>
								</>
							) : (
								<>
									<Row>
										<Col>
											<h4 className={`text-${quoteType}`}>Edit Quote</h4>
										</Col>
									</Row>

									<Row>
										<Col>
											Would you like to unlock and edit this quote? Pricing
											will be recalculated for each item that you edit.
										</Col>
										<Row>
											<Col>{extraMessage ?? null}</Col>
										</Row>
									</Row>
								</>
							)}

							{this.state.loading ? (
								<Row className="pt-5">
									<Col className="text-center">
										<SpinningWheel
											className={`text-${quoteType}`}
											style={{ fontSize: '2.5em' }}
										/>
									</Col>
								</Row>
							) : (
								<Row className="pt-5">
									<Col xs={6}>
										<Button
											color={quoteType}
											onClick={() => {
												if (
													shadesThatNeedRepricing.length > 0 ||
													quoteAccessoriesNeedingUnlocked.length > 0
												) {
													shadesThatNeedRepricing.forEach((s) =>
														self.props.unlockShade(s.sequence_id)
													);
													quoteAccessoriesNeedingUnlocked.forEach((a) =>
														this.props.newQuote.Data.setAccessoryQuantity(
															a,
															a.quantity
														)
													);
												}
												this.unlockQuote(() => {
													close();
													showEditQuoteDisclaimer.action &&
														showEditQuoteDisclaimer.action();
												});
												(self.props.showEditQuoteDisclaimer === true
													? () => {}
													: this.props.unlockShade)(
													self.props.showEditQuoteDisclaimer - 1
												);
											}}
										>
											Unlock and Edit
										</Button>
									</Col>
									<Col xs={6} className="text-end">
										<Button
											color="grey"
											onClick={() => {
												this.props.lockAllShades();
												close();
											}}
										>
											View Only
										</Button>
									</Col>
								</Row>
							)}
						</Container>
					)}
				</Popup>
			</>
		);
	}
}

export default QuotePricingLockedNew;
